export const TagValues: any = {
  'showall': "Show all",
  'education': 'Education',
  'usersuccessstory': 'User Story',
  'newrelease-feature': 'Release',
  'announcement': 'Announcement',
  'data-platform': 'Data Platform',
  'serverless': 'Serverless',
  'orm': 'Prisma ORM',
}
